import API_BASE_URL from '../Config';

export const getEstadosCiviles = async (token) => {
    const response = await fetch(`${API_BASE_URL}/estados-civiles`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar estados civiles');
    return response.json();
};

export const getEstadosCivilesPaginadas = async (token, page = 0, size = 10, search = '') => {
    const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
        search: search
    });

    const response = await fetch(`${API_BASE_URL}/estados-civiles/page?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar estados civiles paginados');
    return response.json();
};

export const getEstadoCivilById = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/estados-civiles/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar el estado civil');
    return response.json();
};

export const createEstadoCivil = async (token, data) => {
    const response = await fetch(`${API_BASE_URL}/estados-civiles`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al crear el estado civil');
    return response.json();
};

export const updateEstadoCivil = async (token, id, data) => {
    const response = await fetch(`${API_BASE_URL}/estados-civiles/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al actualizar el estado civil');
    return response.json();
};

export const darDeBajaEstadoCivil = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/estados-civiles/${id}/dar-baja`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al dar de baja el estado civil');
};

export const deleteEstadoCivil = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/estados-civiles/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al eliminar el estado civil');
};
